/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as _ from 'lodash';

import {AdnHttpService} from '../../../util/adn-http.service';
import {createAdnHttpResource, createAdnHttpResourceSender} from '../../../util/create-adn-http-resource';
import {LocalUserProfile} from '../../../session/local-user-profile';
import {AuthHttpInterceptorService} from '../../../auth/auth-http-interceptor.service';
import {ApiErrorHandlerService} from '../../../../app/common/directives/error/api-error-handler.service';
import {TeamResource} from './team.resource';

/** Angular DI token for the User HTTP resource (factory product). */
export class UserResource {
}

export function createUserResource(
  AdnHttp: AdnHttpService,
  authHttpInterceptor: AuthHttpInterceptorService,
  ApiErrorHandler: ApiErrorHandlerService,
  localUserProfile: LocalUserProfile,
  Team: any
): any {
  const transformRequest = function(data: any) {
    // if no password is set (i.e. update user), then don't send through the password at all.
    if (_.has(data, 'password') && _.trim(data.password).length === 0) {
      return _.omit(data, 'password');
    }
    return data;
  };
  const User = createAdnHttpResource(
    createAdnHttpResourceSender(AdnHttp, authHttpInterceptor, ApiErrorHandler),
    'users',
    () => localUserProfile,
    undefined,
    undefined,
    {transformRequest}
  );

  User.create = function(defaults) {
    return new User(_.assign({
      networkGroups: []
    }, defaults));
  };

  User.getDataView = function(params, networkId) {
    return User.get(params).$promise.then(function(user) {
      const networkGroup = _.find(user.networkGroups, ['network.id', networkId]);
      return Team.query(_.map(_.get(networkGroup, 'groups'), 'id')).$promise.then(function(page) {
        _.set(networkGroup, 'groups', page.results);
        return user;
      });
    });
  };

  User.getUserByUsername = function(username) {
    return User.query({username: username}).$promise.then(function(page) {
      if (page.totalCount === 1) {
        return page.results[0];
      }
      return Promise.reject('Expected 1 user, got ' + page.totalCount);
    });
  };

  return User;
}

export const userResourceProvider = {
  provide: UserResource,
  useFactory: createUserResource,
  deps: [AdnHttpService, AuthHttpInterceptorService, ApiErrorHandlerService, LocalUserProfile, TeamResource]
};

